import { Component, createRef } from 'react';
import type { RefObject } from 'react';
import { Consumer } from '@/context/HighChartsProvider';
import { ChartWrapper } from './styled';
import type { SWSHighCharts } from '@/context/HighChartsProvider';

interface Props {
  options: any;
  modifier: string;
}

class Chart extends Component<Props> {
  private chart: any;
  private HighCharts: SWSHighCharts;
  private chartElement: RefObject<HTMLDivElement>;
  private hasRenderedChart = false;

  constructor(props) {
    super(props);
    this.chartElement = createRef<HTMLDivElement>();
  }

  componentDidMount() {
    const { handleChartRender } = this;
    setTimeout(handleChartRender);
  }

  componentWillUnmount() {
    if (this.chart) {
      const chart = this.chart;
      // Schedule this chart to be cleaned up in the next 4 seconds
      // This prevents a dogpiling effect where X amount of charts in a subtree all try to destroy at the same time
      setTimeout(() => chart.destroy(), Math.floor(Math.random() * 4000));
    }
  }

  componentDidUpdate(prevProps) {
    const { modifier } = this.props;
    const { hasRenderedChart, handleChartRender } = this;

    const { modifier: prevModifier } = prevProps;
    if (
      modifier &&
      typeof modifier === 'string' &&
      modifier.length > 0 &&
      modifier !== prevModifier &&
      hasRenderedChart === true
    ) {
      // console.log('⚠️️ EXPENSIVE RENDER ⚠️', modifier);
      setTimeout(handleChartRender);
    }
  }

  handleChartRender = () => {
    const isServerSide = RUNTIME_ENV === 'server';
    const { current } = this.chartElement;

    if (!isServerSide && current) {
      const { options } = this.props;
      try {
        this.chart = new this.HighCharts['Chart'](current, options);
        this.hasRenderedChart = true;
      } catch (error) {
        console.error(error);
      }
    }
  };

  // Ref is breaking the app
  // https://reactjs.org/warnings/refs-must-have-owner.html
  // https://reactjs.org/docs/refs-and-the-dom.html#when-to-use-refs

  render() {
    const { chartElement } = this;
    const {
      options: {
        chart: { height },
      },
    } = this.props;
    return (
      <Consumer>
        {(value) => {
          if (!value) return;
          this.HighCharts = value.highCharts;
          return <ChartWrapper height={height} ref={chartElement} />;
        }}
      </Consumer>
    );
  }
}

export default Chart;
